module.exports = __webpack_public_path__ + "media/images/flags/16/Netherlands-Antilles-78108693fcce860c62e6d32bcc6fbcb9.png";